import axios from "axios";
import { useState, useEffect, useMemo, useContext } from "react";
import { useAlert } from "react-alert";
import { Modal } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import assessmentImg from "../../../images/practice-assessment.svg";
import onlinetestImg from "../../../images/online-test.svg";

import DropdownComponent from "../../DropdownComponent/DropdownComponent";

import { GlobalContext } from "../../../context/GlobalState";
import GradeSorter from "../../../utils/gradeSorter";

import "../css/Assesment.css";

const testType = [
  { value: "Chapter Test" },
  { value: "Unit Test" },
  { value: "Half Yearly" },
  { value: "Final Test" },
];

const parseGrades = (grades) => {
  const newGrades = [];

  grades.forEach((gradeSection) => {
    const [grade, section] = gradeSection._id.split("-");
    const gradeIndex = newGrades.findIndex(
      (newGrade) => newGrade.grade === grade
    );
    const sectionId = gradeSection.subjects[0]?.sectionId || "";
    if (gradeIndex > -1) {
      newGrades[gradeIndex].sections.push({
        sectionId,
        section,
        subjects: gradeSection.subjects,
      });
    } else {
      newGrades.push({
        grade,
        sections: [
          {
            section,
            sectionId,
            subjects: gradeSection.subjects,
          },
        ],
      });
    }
  });
  return newGrades;
};

const Assesment = () => {
  const { userDetails, setUserDetails } = useContext(GlobalContext);
  const alert = useAlert();

  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);

  const [practiceAssessment, setPracticeAssessment] = useState({
    class: "Class",
    section: "Section",
    subject: "Subject",
    tyt: "Type Of Test",
    chapter: "Chapter",
    topic: [],
    subtopic: "Sub-Topic",
  });

  const handleClose = () => {
    setShow(false);
    setPracticeAssessment({
      class: "Class",
      section: "Section",
      subject: "Subject",
      tyt: "Type Of Test",
      chapter: "Chapter",
      topic: "Topic",
      subtopic: "Sub-Topic",
    });
  };
  const handleShow = () => {
    setShow(true);
  };
  const handleClose1 = () => {
    setShow1(false);
    setPracticeAssessment({
      class: "Class",
      section: "Section",
      subject: "Subject",
      tyt: "Type Of Test",
      chapter: "Chapter",
      topic: [],
      subtopic: "Sub-Topic",
    });
  };
  const handleShow1 = () => setShow1(true);

  const [assignedClasses, setAssignedClasses] = useState([]);

  const [sectionId, setSectionId] = useState("");
  const [subjectId, setSubjectId] = useState("");
  const [chapterId, setChapterId] = useState("");
  const [topicId, setTopicId] = useState([]);
  const [chapters, setChapters] = useState([]);
  const [topics, setTopics] = useState([]);
  const [modules, setModules] = useState([]);
  const [moduleStatus, setModuleStatus] = useState(false);

  useEffect(() => {
    const fetchClasses = async () => {
      const authToken = localStorage.getItem("authToken");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN}/api/v1/staffs/${userDetails.userId}/assignSubjects`,
          {
            headers: {
              token: authToken,
            },
          }
        );
        if (response.data.status === "success") {
          setAssignedClasses([
            new GradeSorter(response.data.data.sections).sort(),
          ]);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchClasses();
  }, []);

  useEffect(() => {
    if (!sectionId || !subjectId) return;

    const getChapters = async () => {
      const authToken = localStorage.getItem("authToken");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN2}/api/v1/staffs/${userDetails.userId}/sections/${sectionId}/subjects/${subjectId}/chapters`,
          {
            headers: {
              token: authToken,
            },
          }
        );

        if (response.data.status === "success") {
          setChapters(response.data.data.chapters);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getChapters();
  }, [sectionId, subjectId]);

  useEffect(() => {
    if (!sectionId || !subjectId || !chapterId) return;
    const getTopics = async () => {
      const authToken = localStorage.getItem("authToken");

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN2}/api/v1/staffs/${userDetails.userId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/topics`,
          {
            headers: {
              token: authToken,
            },
          }
        );
        if (response.data.status === "success") {
          setTopics(response.data.data.topics);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getTopics();
  }, [sectionId, subjectId, chapterId]);

  useEffect(() => {
    if (!subjectId || !sectionId || !chapterId || !topicId) return;

    const getModules = async () => {
      const authToken = localStorage.getItem("authToken");
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_ORIGIN2}/api/v1/staffs/${userDetails.userId}/sections/${sectionId}/subjects/${subjectId}/chapters/${chapterId}/topics/${topicId}/modules`,
          {
            headers: {
              token: authToken,
            },
          }
        );

        if (response.data.status === "success") {
          setModules(response.data.data.modules);
        }
      } catch (error) {
        console.log(error);
      }
    };

    getModules();
  }, [subjectId, sectionId, chapterId, topicId]);

  const newClass = useMemo(() => {
    const classes = [];
    assignedClasses?.forEach((list) => {
      list.forEach((x) => {
        classes.push(x);
      });
    });
    return classes;
  }, [assignedClasses]);

  const newgrade = useMemo(() => {
    return parseGrades(newClass);
  }, [newClass]);

  const { grade, section } = useMemo(() => {
    const data = { grade: [], section: [] };
    newgrade.forEach((x) => {
      data.grade.push(x.grade);
      if (x.grade === practiceAssessment.class) {
        data.section = x.sections;
      }
    });
    return data;
  }, [newgrade, practiceAssessment.class]);

  const { subject } = useMemo(() => {
    const data = { subject: [] };
    //Save selected sectionId in localstorage
    window.localStorage.setItem(
      "sections",
      JSON.stringify({
        sections: section
          .filter((sec) => practiceAssessment.section.includes(sec.section))
          .map((sec) => sec.sectionId),
      })
    );
    section.forEach((x) => {
      if (practiceAssessment.section.includes(x.section)) {
        data.subject = x.subjects;
      }
    });
    
   
    return data;
  }, [section, practiceAssessment.section]);

  useEffect(() => {
    setSubjectId("");
  },[subject]);

  useEffect(() => {
    console.log("Subject changed", subjectId)
    setChapterId("");
    setTopicId("");
  }, [subjectId]);

  return (
    <>
      <Modal
        show={show}
        onHide={handleClose}
        animation={false}
        centered
        className="practise_assessment_modal_head"
      >
        <Modal.Body>
          <div className="practise_assessment_modal">
            <div className="practise_assessment_modal_top">
              <div className="practise_assessment_heading">
                <svg
                  width="18"
                  height="23"
                  viewBox="0 0 18 23"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.5 0C6.67157 0 6 0.643591 6 1.4375C6 2.23141 6.67157 2.875 7.5 2.875H10.5C11.3284 2.875 12 2.23141 12 1.4375C12 0.643591 11.3284 0 10.5 0H7.5Z"
                    fill="black"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M0 4.3125C0 2.72468 1.34315 1.4375 3 1.4375C3 3.81923 5.01472 5.75 7.5 5.75H10.5C12.9853 5.75 15 3.81923 15 1.4375C16.6569 1.4375 18 2.72468 18 4.3125V20.125C18 21.7128 16.6569 23 15 23H3C1.34315 23 0 21.7128 0 20.125V4.3125ZM4.5 10.0625C3.67157 10.0625 3 10.7061 3 11.5C3 12.2939 3.67157 12.9375 4.5 12.9375H4.515C5.34343 12.9375 6.015 12.2939 6.015 11.5C6.015 10.7061 5.34343 10.0625 4.515 10.0625H4.5ZM9 10.0625C8.17157 10.0625 7.5 10.7061 7.5 11.5C7.5 12.2939 8.17157 12.9375 9 12.9375H13.5C14.3284 12.9375 15 12.2939 15 11.5C15 10.7061 14.3284 10.0625 13.5 10.0625H9ZM4.5 15.8125C3.67157 15.8125 3 16.4561 3 17.25C3 18.0439 3.67157 18.6875 4.5 18.6875H4.515C5.34343 18.6875 6.015 18.0439 6.015 17.25C6.015 16.4561 5.34343 15.8125 4.515 15.8125H4.5ZM9 15.8125C8.17157 15.8125 7.5 16.4561 7.5 17.25C7.5 18.0439 8.17157 18.6875 9 18.6875H13.5C14.3284 18.6875 15 18.0439 15 17.25C15 16.4561 14.3284 15.8125 13.5 15.8125H9Z"
                    fill="black"
                  />
                </svg>
                <span>PRACTICE SESSION</span>
              </div>
              <div className="practise_assessment_fields">
                <DropdownComponent
                  type="class"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={grade}
                />
                <DropdownComponent
                  type="section"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={section}
                  disable={
                    practiceAssessment.class &&
                    practiceAssessment.class != "Class"
                      ? false
                      : true
                  }
                />
                <DropdownComponent
                  type="subject"
                  placeholder={"Subject"}
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={subject}
                  outerValue={subjectId}
                  setSubjectId={setSubjectId}
                  setSectionId={setSectionId}
                  disable={
                    practiceAssessment.section &&
                    practiceAssessment.section != "Section"
                      ? false
                      : true
                  }
                />
                {/* <Checkbox className="check_drop" /> */}
                <DropdownComponent
                  type="chapter"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={chapters}
                  setChapterId={setChapterId}
                  outerValue={chapterId}
                  disable={
                    practiceAssessment.subject &&
                    practiceAssessment.subject != "Subject"
                      ? false
                      : true
                  }
                />
                <DropdownComponent
                  type="topic"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  outerValue={topicId}
                  content={topics}
                  setTopicId={setTopicId}
                  setModuleStatus={setModuleStatus}
                  disable={
                    practiceAssessment.chapter &&
                    practiceAssessment.chapter != "Chapter"
                      ? false
                      : true
                  }
                />
                {/*<DropdownComponent
                  type="subtopic"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={modules}
                  disable={
                    practiceAssessment.topic &&
                    practiceAssessment.topic != "Topic" &&
                    !moduleStatus
                      ? false
                      : true
                  }
                />*/}
              </div>
              <div className="practise_assessment_modal_bot">
                <button
                  className="practise_assessment_modal_cancel"
                  onClick={handleClose}
                >
                  Cancel
                </button>
                {practiceAssessment.topic.length != 0 ? (
                  <NavLink
                    to={{
                      pathname: `/myassessment/${practiceAssessment.subject}/${subjectId}/practiseAssessment`,
                      state: {
                        subjectId: subjectId,
                        sectionId: sectionId,
                        topicId: topicId,
                        chapterId: chapterId,
                        practiceAssessment: practiceAssessment,
                      },
                    }}
                  >
                    <button
                      onClick={() => {
                        setUserDetails({
                          ...userDetails,
                          selectedTab: "Practice Session",
                          pathName: {
                            className: `${practiceAssessment.class}`,
                            sectionName: `${practiceAssessment.section}`,
                            subjectName: `${practiceAssessment.subject}`,
                            chapterName: `${practiceAssessment.chapter}`,
                            topicName: `${practiceAssessment.topic}`,
                          },
                        });
                      }}
                      className="practise_assessment_modal_save"
                    >
                      Save
                    </button>
                  </NavLink>
                ) : (
                  <button
                    className="practise_assessment_modal_save"
                    onClick={() => {
                      alert.error("Error please select Topic");
                    }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={show1}
        onHide={handleClose1}
        animation={false}
        centered
        className="online_test_modal_head"
      >
        <Modal.Body>
          <div className="online_test_modal">
            <div className="online_test_modal_top">
              <div className="online_test_heading">
                <svg
                  width="21"
                  height="21"
                  viewBox="0 0 21 21"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  xlink="http://www.w3.org/1999/xlink"
                >
                  <rect width="21" height="21" fill="url(#pattern0)" />
                  <defs>
                    <pattern
                      id="pattern0"
                      patternContentUnits="objectBoundingBox"
                      width="1"
                      height="1"
                    >
                      <use
                        href="#image0_945_27277"
                        transform="translate(-0.0236025) scale(0.00124224)"
                      />
                    </pattern>
                    <image
                      id="image0_945_27277"
                      width="843"
                      height="805"
                      href="data:image/png;base64,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"
                    />
                  </defs>
                </svg>
                <span>ONLINE TEST</span>
              </div>
              <div className="online_test_fields">
                <DropdownComponent
                  content={testType}
                  type="tyt"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  onlinetest={true}
                />
                <DropdownComponent
                  type="class"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={grade || []}
                  disable={
                    practiceAssessment.tyt &&
                    practiceAssessment.tyt != "Type Of Test"
                      ? false
                      : true
                  }
                  onlinetest={true}
                />
                <DropdownComponent
                  type="sections"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={section || []}
                  disable={
                    practiceAssessment.class &&
                    practiceAssessment.class != "Class"
                      ? false
                      : true
                  }
                  onlinetest={true}
                  placeholder={"Section"}
                />
                <DropdownComponent
                  type="subject"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={subject || []}
                  setSubjectId={setSubjectId}
                  setSectionId={setSectionId}
                  disable={
                    practiceAssessment.section &&
                    practiceAssessment.section != "Section"
                      ? false
                      : true
                  }
                  onlinetest={true}
                />
                <DropdownComponent
                  type="chapter"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={chapters}
                  setChapterId={setChapterId}
                  disable={
                    practiceAssessment.subject &&
                    practiceAssessment.subject != "Subject"
                      ? false
                      : true
                  }
                  onlinetest={true}
                />
                <DropdownComponent
                  type="topic"
                  practiceAssessment={practiceAssessment}
                  setPracticeAssessment={setPracticeAssessment}
                  content={topics}
                  setTopicId={setTopicId}
                  setModuleStatus={setModuleStatus}
                  onlinetest={true}
                />
              </div>
              <div className="online_test_modal_bot">
                <button
                  className="online_test_modal_cancel"
                  onClick={handleClose1}
                >
                  Cancel
                </button>
                {practiceAssessment.chapter.length != 0 ? (
                  <NavLink
                    to={{
                      pathname: `/myassessment/${practiceAssessment.subject}/${subjectId}/onlinetest`,
                      state: {
                        subjectId: subjectId,
                        sectionId: sectionId,
                        topicId: topicId,
                        chapterId: chapterId,
                        practiceAssessment: practiceAssessment,
                        grade: grade,
                        subject: subject,
                        chapters: chapters,
                        modules: modules,
                      },
                    }}
                  >
                    <button
                      className="online_test_modal_save"
                      // onClick={handleClose}
                      onClick={
                        (handleClose,
                        () => {
                          setUserDetails({
                            ...userDetails,
                            selectedTab: "Online Test",
                            pathName: {
                              className: `${practiceAssessment.class}`,
                              sectionName: `${practiceAssessment.section}`,
                              subjectName: `${practiceAssessment.subject}`,
                              chapterName: `${practiceAssessment.chapter}`,
                              topicName: `${practiceAssessment?.topic}`,
                            },
                          });
                        })
                      }
                    >
                      Save
                    </button>
                  </NavLink>
                ) : (
                  <button
                    className="online_test_modal_save"
                    onClick={() => {
                      alert.error("Error please select Chapter");
                    }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <div className="assesment">
        <div className="assesment__practise">
          <button className="assesment__practise__action" onClick={handleShow}>
            <img src={assessmentImg} />
            <span>Practice Assessment</span>
            <svg
              width="38"
              height="38"
              viewBox="0 0 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM27.8044 17.3206L20.6794 10.1956C19.7519 9.26813 18.2481 9.26813 17.3206 10.1956C16.3931 11.1231 16.3931 12.6269 17.3206 13.5544L20.3912 16.625L11.875 16.625C10.5633 16.625 9.5 17.6883 9.5 19C9.5 20.3117 10.5633 21.375 11.875 21.375H20.3912L17.3206 24.4456C16.3931 25.3731 16.3931 26.8769 17.3206 27.8044C18.2481 28.7319 19.7519 28.7319 20.6794 27.8044L27.8044 20.6794C28.7319 19.7519 28.7319 18.2481 27.8044 17.3206Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
        <div className="assesment__onlineTest">
          <button
            className="assesment__onlineTest__action"
            onClick={handleShow1}
          >
            <img src={onlinetestImg} />
            <span>Online Test</span>
            <svg
              width="38"
              height="38"
              viewBox="0 0 38 38"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M19 38C29.4934 38 38 29.4934 38 19C38 8.50659 29.4934 0 19 0C8.50659 0 0 8.50659 0 19C0 29.4934 8.50659 38 19 38ZM27.8044 17.3206L20.6794 10.1956C19.7519 9.26813 18.2481 9.26813 17.3206 10.1956C16.3931 11.1231 16.3931 12.6269 17.3206 13.5544L20.3912 16.625L11.875 16.625C10.5633 16.625 9.5 17.6883 9.5 19C9.5 20.3117 10.5633 21.375 11.875 21.375H20.3912L17.3206 24.4456C16.3931 25.3731 16.3931 26.8769 17.3206 27.8044C18.2481 28.7319 19.7519 28.7319 20.6794 27.8044L27.8044 20.6794C28.7319 19.7519 28.7319 18.2481 27.8044 17.3206Z"
                fill="white"
              />
            </svg>
          </button>
        </div>
      </div>
    </>
  );
};

export default Assesment;
